import { exchangeIDAuth, getUrlParam } from "@/hooks";
import endevreID from "@endevre/id-client";
import LoadingScreen from "../components/loadingscreen";

export const clientID = process.env.REACT_APP_ENDEVRE_CLIENT_ID || "";
export const secret = process.env.REACT_APP_ENDEVRE_CLIENT_SECRET || "";

export default function Auth() {
  const client = endevreID.createClient(clientID, secret);

  const code = getUrlParam("code");
  const pairingID = getUrlParam("pairingID");
  const currentDomain = window.location.hostname;
  const httpProtocol = window.location.protocol;
  const fullDomain = `${httpProtocol}//${currentDomain}${
    window.location.port ? `:${window.location.port}` : ""
  }`;

  exchangeIDAuth(code, fullDomain).then((response) => {
    console.log("exchangeIDAuthResponse", response);

    const data = response.data;

    client.setClientCookies(data, pairingID);
  });

  return (
    <div className="flex flex-col items-center justify-center h-screen w-full">
      <LoadingScreen />
    </div>
  );
}
